import React from 'react';
import { ViewMoreLink } from 'components/common/ViewMoreLink';
import {
  RegistryDashboardWrapper,
  Header,
  Title,
  RegistryDashboardContent,
  HeatmapContainer,
  PieChartContainer,
} from './styles';
import {
  AgeGraph,
  StatesHeatMapGraph,
} from 'components/RegistryDashboard/Graphs';

export const RegistryDashboard = () => {
  return (
    <RegistryDashboardWrapper>
      <Header
        sx={{
          display       : 'flex',
          flexDirection : { xs: 'column', md: 'row' },
        }}>
        <Title>Registry Dashboard</Title>
        <ViewMoreLink
          to='registry'>View all</ViewMoreLink>
      </Header>
      <RegistryDashboardContent
        sx={{
          flexDirection : { xs: 'column', md: 'row' },
          padding       : { xs: 0, lg: '20px 50px' },
        }}>
        <HeatmapContainer>
          <StatesHeatMapGraph
            id='heat-map'
            label='US Heatmap'
            width='460px'
            height='350px'
          />
        </HeatmapContainer>
        <PieChartContainer
          sx={{
            display       : 'flex',
            flexDirection : 'column',
            marginTop     : { xs: 4, md: 0 },
          }}>
          <AgeGraph
            id='age-pie-chart'
            label='Age'
            width='460px'
            height='450px'
            legendOptions={{
              top    : '25%',
              right  : '10%',
              orient : 'vertical',
            }}
          />
        </PieChartContainer>
      </RegistryDashboardContent>
    </RegistryDashboardWrapper>
  );
};
